import { createFormAction } from 'redux-form-saga'

const getAllBLEDataAction = createFormAction('GET_ALL_BLE_DATA')

export { getAllBLEDataAction }
